package com.cybergstudios.rtc.levels

import com.cybergstudios.rtc.engine.Color
import com.cybergstudios.rtc.math.Vec2
import com.cybergstudios.rtc.world.Grid
import com.cybergstudios.rtc.world.Polygon
import com.cybergstudios.rtc.world.Rectangle

object Level01 : Level {

    /** The square side size */
    private val sw: Double = 24.0

    private val color = Color(252.0, 90.0, 184.0, 1.0)

    override fun build(): Grid {
        val leftEye = eye().add(Vec2(-3.5, 5.5)).scale(sw)
        val rightEye = eye().add(Vec2(0.5, 5.5)).scale(sw)
        val leftEar = leftEar()
        val rightEar = rightEar()
        val leftTopMustache = topMustache().add(Vec2(-5.5, 0.5)).scale(sw)
        val rightTopMustache = topMustache().add(Vec2(2.5, 0.5)).scale(sw)
        val leftBottomMustache = leftBottomMustache()
        val rightBottomMustache = rightBottomMustache()
        return Grid(
            listOf(
                nose(),
                leftEye,
                rightEye,
                leftEar,
                rightEar,
                leftTopMustache,
                rightTopMustache,
                leftBottomMustache,
                rightBottomMustache
            )
        )
    }

    override fun nextLevel(): Level? = null

    private fun nose(): Polygon {
        val points = listOf(Vec2(0.0, 0.0), Vec2(1.0, 0.0), Vec2(1.0, -1.0), Vec2(0.0, -1.0))
        val mainRectangle = Rectangle(Vec2(0.0, 0.0), Vec2(1.0, -1.0))
        val rectangles = listOf(mainRectangle)
        return Polygon(points, mainRectangle, rectangles, color, true)
            .add(Vec2(-0.5, 0.5))
            .scale(sw)

    }

    private fun eye(): Polygon {
        val points = listOf(Vec2(0.0, 0.0), Vec2(3.0, 0.0), Vec2(3.0, -4.0), Vec2(0.0, -4.0))
        val mainRectangle = Rectangle(Vec2(0.0, 0.0), Vec2(3.0, -4.0))
        val rectangles = listOf(mainRectangle)
        return Polygon(points, mainRectangle, rectangles, color, true)
    }

    private fun leftEar(): Polygon {
        val points = listOf(
            Vec2(0.0, 0.0),
            Vec2(2.0, 0.0),
            Vec2(2.0, -1.0),
            Vec2(1.0, -1.0),
            Vec2(1.0, -2.0),
            Vec2(0.0, -2.0),
        )
        val mainRectangle = Rectangle(Vec2(0.0, 0.0), Vec2(2.0, -2.0))
        val rectangles = listOf(
            Rectangle(Vec2(0.0, 0.0), Vec2(2.0, -1.0)),
            Rectangle(Vec2(0.0, -1.0), Vec2(1.0, -2.0))
        )
        return Polygon(points, mainRectangle, rectangles, color, true)
            .add(Vec2(-5.5, 7.5))
            .scale(sw)
    }

    private fun rightEar(): Polygon {
        val points = listOf(
            Vec2(0.0, 0.0),
            Vec2(2.0, 0.0),
            Vec2(2.0, -2.0),
            Vec2(1.0, -2.0),
            Vec2(1.0, -1.0),
            Vec2(0.0, -1.0),
        )
        val mainRectangle = Rectangle(Vec2(0.0, 0.0), Vec2(2.0, -2.0))
        val rectangles = listOf(
            Rectangle(Vec2(0.0, 0.0), Vec2(2.0, -1.0)),
            Rectangle(Vec2(1.0, -1.0), Vec2(2.0, -2.0))
        )
        return Polygon(points, mainRectangle, rectangles, color, true)
            .add(Vec2(3.5, 7.5))
            .scale(sw)
    }

    private fun topMustache(): Polygon {
        val points = listOf(
            Vec2(0.0, 0.0),
            Vec2(3.0, 0.0),
            Vec2(3.0, -1.0),
            Vec2(0.0, -1.0),
        )
        val mainRectangle = Rectangle(Vec2(0.0, 0.0), Vec2(3.0, -1.0))
        val rectangles = listOf(mainRectangle)
        return Polygon(points, mainRectangle, rectangles, color, true)
    }

    private fun leftBottomMustache(): Polygon {
        val points = listOf(
            Vec2(0.0, 0.0),
            Vec2(2.0, 0.0),
            Vec2(2.0, -1.0),
            Vec2(0.0, -1.0),
            Vec2(0.0, -2.0),
            Vec2(-1.0, -2.0),
            Vec2(-1.0, -1.0),
            Vec2(0.0, -1.0),
        )
        val mainRectangle = Rectangle(Vec2(-1.0, 0.0), Vec2(2.0, -2.0))
        val rectangles = listOf(
            Rectangle(Vec2(0.0, 0.0), Vec2(2.0, -1.0)),
            Rectangle(Vec2(-1.0, -1.0), Vec2(0.0, -2.0))
        )
        return Polygon(points, mainRectangle, rectangles, color, true)
            .add(Vec2(-4.5, -1.5))
            .scale(sw)
    }

    private fun rightBottomMustache(): Polygon {
        val points = listOf(
            Vec2(0.0, 0.0),
            Vec2(2.0, 0.0),
            Vec2(2.0, -1.0),
            Vec2(3.0, -1.0),
            Vec2(3.0, -2.0),
            Vec2(2.0, -2.0),
            Vec2(2.0, -1.0),
            Vec2(0.0, -1.0),
        )
        val mainRectangle = Rectangle(Vec2(0.0, 0.0), Vec2(3.0, -2.0))
        val rectangles = listOf(
            Rectangle(Vec2(0.0, 0.0), Vec2(2.0, -1.0)),
            Rectangle(Vec2(2.0, -1.0), Vec2(3.0, -2.0))
        )
        return Polygon(points, mainRectangle, rectangles, color, true)
            .add(Vec2(2.5, -1.5))
            .scale(sw)
    }

}
